<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 sm-offset-2 lg6 lg-offset-3>
          <v-card elavation-20 style="text-align: center">
            <v-responsive>
              <img src="../assets/wynum_02@2x.png" style="margin-top:50px;width:50%">
              <!--<h1 style="margin-top:50px;width:50%;font-size:70px;color:blue;margin-left:150px">Wynum</h1>-->
            </v-responsive>
            <v-card-text>
              <h2 style="margin-top:20px;margin-bottom:20px">Sign in to Wynum Logistics</h2>
              <v-form ref="form">
                <p v-show="message">Phone Number is already registered</p>
                <v-text-field
                  v-model="email"
                  label="Please specify your registered email id"
                  type="text"
                ></v-text-field>
                <v-text-field
                  v-model="password"
                  label="Please enter your password"
                  type="password"
                ></v-text-field>
                <v-btn color="primary" large @click="login()" :class="{ disabled: isDisabled }" :disabled="isDisabled">Sign In</v-btn>
                <v-layout row>
                  <v-flex xs6>
                    <v-checkbox
                      :label="`Remember me`"
                      v-model="checkbox"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex>
                    <v-btn color="primary" flat small style="margin-top:20px">Need Help?</v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      error: '',
      password: '',
      message: false,
      title: '',
      flag: false,
      checkbox: true
    }
  },
  computed: {
    isDisabled () {
      if (this.email !== '' && this.password !== '') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    login () {
      this.$router.push('/Dashboard')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue